import { API_BASE_URL } from './api';

// Private files deliberately bypass the shared API cache and use authenticated
// blob downloads rather than public links or tokens in query strings.
const request = async (instructorId, action, options = {}) => {
  const token = sessionStorage.getItem('authToken') || localStorage.getItem('authToken') || localStorage.getItem('admin_token');
  const response = await fetch(`${API_BASE_URL}/instructor-files/${encodeURIComponent(instructorId)}/${action}`, {
    ...options,
    cache: 'no-store',
    headers: { Authorization: `Bearer ${token || ''}` },
  });
  if (!response.ok) {
    const data = await response.json().catch(() => ({}));
    throw new Error(data.message || `Request failed (${response.status})`);
  }
  return response;
};

export const instructorFileAPI = {
  list: async (id) => (await request(id, 'list')).json(),
  upload: async (id, file) => {
    const body = new FormData();
    body.append('file', file);
    return (await request(id, 'upload', { method: 'POST', body })).json();
  },
  download: async (id, file) => {
    const response = await request(id, `download?key=${encodeURIComponent(file.fullKey)}`);
    const url = URL.createObjectURL(await response.blob());
    const link = document.createElement('a');
    link.href = url;
    link.download = file.key;
    document.body.appendChild(link);
    link.click();
    link.remove();
    setTimeout(() => URL.revokeObjectURL(url), 1000);
  },
  delete: async (id, key) => (await request(id, `delete?key=${encodeURIComponent(key)}`, { method: 'DELETE' })).json(),
};
